import React from 'react'
import { Splide, SplideTrack, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import '@splidejs/react-splide/css/core';
const PartnerTestimonial = () => {
    return (
        <div className="_testimonial_nft_wrapper">
            <div className="_testimonial_nft_wrap">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12">
                            <div className="_testimonial_nft_slider">
                                {/* <div className="splide__track">
                                    <div className="splide__list">
                                        <div className="splide__slide">
                                            <div className="row align-items-center">
                                                <div className="col-xl-5 col-lg-5 col-md-5">
                                                    <div className="_testimonial_nft_slider_left">
                                                        <div className="_testimonial_nft_slider_left_img">
                                                            <img src="assets/img/testimonial-slider-img.png" alt="chobi" className="_testimonial_nft_slider_left_img_tag" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xl-7 col-lg-7 col-md-7">
                                                    <div className="_testimonial_nft_slider_r8">
                                                        <p className="_testimonial_nft_slider_r8_para">OpenSea is one of the
                                                            most exciting, important companies in the world right
                                                            now because it's the portal to the new digital economy.
                                                            If you're interested in shaping a new business model
                                                            for creators, this is the team to join.</p>
                                                        <div className="_testimonial_nft_slider_r8_info">
                                                            <h6 className="_testimonial_nft_slider_r8_info_txt">jhon week</h6>
                                                            <p className="_testimonial_nft_slider_r8_info_para">General Partner
                                                                at allblocks</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="splide__slide">
                                            <div className="row align-items-center">
                                                <div className="col-xl-5 col-lg-5 col-md-5">
                                                    <div className="_testimonial_nft_slider_left">
                                                        <div className="_testimonial_nft_slider_left_img">
                                                            <img src="assets/img/testimonial-slider-img.png" alt="chobi" className="_testimonial_nft_slider_left_img_tag" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xl-7 col-lg-7 col-md-7">
                                                    <div className="_testimonial_nft_slider_r8">
                                                        <p className="_testimonial_nft_slider_r8_para">OpenSea is one of the
                                                            most exciting, important companies in the world right
                                                            now because it's the portal to the new digital economy.
                                                            If you're interested in shaping a new business model
                                                            for creators, this is the team to join.</p>
                                                        <div className="_testimonial_nft_slider_r8_info">
                                                            <h6 className="_testimonial_nft_slider_r8_info_txt">jhon week</h6>
                                                            <p className="_testimonial_nft_slider_r8_info_para">General Partner
                                                                at allblocks</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                                <Splide 
                                hasTrack={false}
                                options={ {
                                    type: 'slide',
                                    perPage: 1,
                                    perMove: 1,
                                    arrows: false,
                                    pagination: false,
                                  } }
                                
                                >
                                    <SplideTrack>
                                        <SplideSlide>
                                        <div className="row align-items-center">
                                                <div className="col-xl-5 col-lg-5 col-md-5">
                                                    <div className="_testimonial_nft_slider_left">
                                                        <div className="_testimonial_nft_slider_left_img">
                                                            <img src="assets/img/testimonial-slider-img.png" alt="chobi" className="_testimonial_nft_slider_left_img_tag" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xl-7 col-lg-7 col-md-7">
                                                    <div className="_testimonial_nft_slider_r8">
                                                        <p className="_testimonial_nft_slider_r8_para">OpenSea is one of the
                                                            most exciting, important companies in the world right
                                                            now because it's the portal to the new digital economy.
                                                            If you're interested in shaping a new business model
                                                            for creators, this is the team to join.</p>
                                                        <div className="_testimonial_nft_slider_r8_info">
                                                            <h6 className="_testimonial_nft_slider_r8_info_txt">jhon week</h6>
                                                            <p className="_testimonial_nft_slider_r8_info_para">General Partner
                                                                at allblocks</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </SplideSlide>
                                        <SplideSlide>
                                        <div className="row align-items-center">
                                                <div className="col-xl-5 col-lg-5 col-md-5">
                                                    <div className="_testimonial_nft_slider_left">
                                                        <div className="_testimonial_nft_slider_left_img">
                                                            <img src="assets/img/testimonial-slider-img.png" alt="chobi" className="_testimonial_nft_slider_left_img_tag" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xl-7 col-lg-7 col-md-7">
                                                    <div className="_testimonial_nft_slider_r8">
                                                        <p className="_testimonial_nft_slider_r8_para">OpenSea is one of the
                                                            most exciting, important companies in the world right
                                                            now because it's the portal to the new digital economy.
                                                            If you're interested in shaping a new business model
                                                            for creators, this is the team to join.</p>
                                                        <div className="_testimonial_nft_slider_r8_info">
                                                            <h6 className="_testimonial_nft_slider_r8_info_txt">jhon week</h6>
                                                            <p className="_testimonial_nft_slider_r8_info_para">General Partner
                                                                at allblocks</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </SplideSlide>
                                    </SplideTrack>
                                </Splide>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default PartnerTestimonial